import React, { useEffect } from 'react'
import { useApolloClient } from 'react-apollo'

import { ACORNS_HELLO_FLOW, USER_UUID, VISITED_PAGES } from 'app-constants'

import { closeSession } from 'utils/auth'
import { withFlowRouter } from 'utils/FlowProvider'

import { Signup as SignupPage } from './Signup'

const Component = () => {
  const apolloClient = useApolloClient()

  useEffect(() => {
    /**
     * We have previously kept all the storage information persisted across sessions
     * This creates issues when a new prospective customer wants to begin sign up
     * We need to clear out any previous session in these cases
     * https://acorns.atlassian.net/browse/GRWTH-6656
     * https://acorns.atlassian.net/browse/GRWTH-10471
     */
    const keys = [ACORNS_HELLO_FLOW, VISITED_PAGES, USER_UUID]
    keys.forEach((key) => {
      window.localStorage.removeItem(key)
      window.sessionStorage.removeItem(key)
    })
    closeSession(apolloClient)
  }, [])

  return <SignupPage />
}

export const Signup = withFlowRouter<{}>(Component as any)
